import React from 'react'
import { FlagProvider, IConfig } from '@unleash/proxy-client-react'
import { IUnleashProviderProps } from './types'

const REFRESH_INTERVAL_IN_SECONDS = 7200

const config: IConfig = {
  url: process.env.REACT_APP_UNLEASH_PROXY_URL,
  clientKey: process.env.REACT_APP_UNLEASH_CLIENT_KEY,
  refreshInterval: REFRESH_INTERVAL_IN_SECONDS,
  appName: 'telavita'
}

export const UnleashProvider = ({children}: IUnleashProviderProps): JSX.Element => (
  <FlagProvider config={config}>
    {children}
  </FlagProvider>
)